import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { PersonSimple } from '../../../model/person';
import { AcceptTermsActionTypes } from './types';

export const acceptTermsRequest = () => action(AcceptTermsActionTypes.ACCEPT_TERMS_REQUEST);
export const acceptTermsSuccess = (person: PersonSimple) => action(AcceptTermsActionTypes.ACCEPT_TERMS_SUCCESS, person);
export const acceptTermsError = (error: GiroWebappError) => action(AcceptTermsActionTypes.ACCEPT_TERMS_ERROR, error);
export const acceptTermsResetState = () => action(AcceptTermsActionTypes.ACCEPT_TERMS_RESET_STATE);
